<template>
  <div>
    <b-container>
      <b-row>
        <b-col>
          <form-wizard ref="wizard">
            <tab-content title="Account Role">
              <b-tabs>
                <b-tab title="New Account Role" active>
                  <b-form-input v-model="accountRoleName" />
                  <b-form-select
                    v-model="accountRoleTemplate"
                    :options="accountRoleTemplates"
                    size="sm"
                    class="mt-3"
                  />
                  <b-form-select
                    v-model="ruleBy"
                    :options="ruleByArr"
                    size="sm"
                    class="mt-3"
                  />
                  <b-form-select
                    v-if="ruleBy"
                    :options="ruleByOptions"
                    size="sm"
                    class="mt-3"
                  />
                </b-tab>
                <b-tab title="Existing Account Role">
                  <indica-list table-name="AccountRoles" />
                </b-tab>
              </b-tabs>
            </tab-content>
            <tab-content title="User">
              <b-tabs>
                <!--                <b-tab title="New User" active>
                                  <indica-form table-name="UserAccounts" @refresh="userAccountCreated"></indica-form>
                                </b-tab>
                                <b-tab title="Existing User">
                                  <indica-list table-name="UserAccounts"
                                               @manyChanged="createAccessControls"
                                               @edit="setUserAccountId" :many-filter="allowedRolesFilter"></indica-list>
                                </b-tab>-->
              </b-tabs>
            </tab-content>
          </form-wizard>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import { FormWizard, TabContent } from "vue-form-wizard";
import "vue-form-wizard/dist/vue-form-wizard.min.css";
import IndicaList from "../../../utils/forms/indica-list";
import { axiosCall } from "../../../utils/axiosCall";

export default {
  name: "ConfigurationWizard",
  components: {
    FormWizard,
    TabContent,
    IndicaList,
  },
  data() {
    return {
      accountRoleName: null,
      accountRoleTemplates: [],
      accountRoleTemplate: null,
      ruleBy: null,
      ruleByArr: [],
      ruleByOptions: [],
    };
  },
  watch: {
    accountRoleTemplate: async function () {
      this.ruleByArr = [];
      const where = {};
      where["where"] = {};
      where["where"]["accountRoleTemplateId"] = this.accountRoleTemplate;
      await axiosCall({
        url: `accessControlTemplates?filter=` + JSON.stringify(where),
        method: "get",
      }).then((response) => {
        let tempArr = [];
        response.data.map((elem) => {
          Object.keys(elem).map((key) => {
            if (key.includes("ruleBy")) {
              tempArr.push(key);
            }
          });
        });
        tempArr = Array.from(new Set(tempArr));
        this.ruleByArr = tempArr.map((r) => {
          return { text: r, value: r };
        });
      });
    },
    ruleBy: async function () {
      this.ruleByOptions = [];
      switch (this.ruleBy) {
        case "ruleByTag":
          await axiosCall({
            url: `Tags`,
            method: "get",
          }).then((response) => {
            response.data.map((tag) => {
              this.ruleByOptions.push({ text: tag.name, value: tag.id });
            });
          });
          break;
        case "ruleByCountry":
          await axiosCall({
            url: `Countries`,
            method: "get",
          }).then((response) => {
            response.data.map((country) => {
              this.ruleByOptions.push({
                text: country.country,
                value: country.id,
              });
            });
          });
          break;
        case "ruleByRegion":
          await axiosCall({
            url: `Tags`,
            method: "get",
          }).then((response) => {
            response.data.map((tag) => {
              this.ruleByOptions.push({ text: tag.name, value: tag.id });
            });
          });
          break;
      }
    },
  },
  created() {
    this.getAccountRoleTemplates();
  },
  methods: {
    getAccountRoleTemplates: async function () {
      await axiosCall({
        url: `accountRoleTemplates`,
        method: "get",
      }).then((response) => {
        this.accountRoleTemplates = response.data.map((d) => {
          return { text: d.name, value: d.id };
        });
      });
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
